import ImpressiveNumbers from './ImpressiveNumbers.svelte';

export default {
  component: ImpressiveNumbers,
  name: 'Impressive Numbers',
  inputs: [
    {
      name: 'title',
      type: 'string'
    },
    {
      name: 'numbersList',
      type: 'list',
      subFields: [
        {
          name: 'number',
          type: 'string'
        },
        {
          name: 'description',
          type: 'richText'
        },
      ]
    },
    {
      name: 'ctaCaption',
      type: 'string'
    },
    {
      name: 'ctaHref',
      type: 'string'
    },
    {
      name: 'ctaLabel',
      type: 'string'
    },
    {
      name: 'disclaimers',
      type: 'list',
      subFields: [
        {
          name: 'disclaimer',
          type: 'string'
        },
      ]
    },
  ]
}
